import { api_POST,api_GET, api_DELETE } from "../api/_axios.js";

const boletimvistoria_api =
{
    postByFilter: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`boletimvistoria/postByFilter`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getListByDashboard: function(situacaoAnalise){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`boletimvistoria/GetListByDashboard/${situacaoAnalise}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getListPedidoVista: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`boletimvistoria/getListPedidoVista`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getItem: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`boletimvistoria/GetItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`boletimvistoria`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    delete: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_DELETE(`boletimvistoria`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default boletimvistoria_api
